import { useState, useCallback, useMemo, useContext, useEffect } from 'react'
import { Box, Button, Card, CardBody, Heading, Grid, Text, Image, Flex, Badge } from '@chakra-ui/react'
import { HStack, Icon, IconButton, } from '@chakra-ui/react'
import { useDisclosure } from '@chakra-ui/react'
import { useRouter } from 'next/router'

import SocialHead from '../../components/head/SocialHead'
import Layout from '../../components/shared/Layout'

import TopBar from '../../components/topbar/TopBar'
import {DesktopView, SelectProject, TabletView} from '../../components/topbar/TopBarAds'
import { useGoogleLogin } from '@react-oauth/google'

import VariationModal from '../../components/modals/VariationModal'
import DeleteVariation from '../../components/modals/DeleteVariation'
import VariationPreviewModal from '../../components/modals/VariationPreviewModal'
import { AdsProvider, AdsContext } from '../../store/ads'
import { UserContext, UserProvider } from '../../store/user'
import axios from 'axios'

import { TrashIcon, PencilSquareIcon, PlusCircleIcon, EyeIcon } from '@heroicons/react/20/solid'

const platformColor = (platform) => {
    if(platform === 'facebook') return "blue" 
    else if(platform === 'instagram') return "red"
}
export const Ads = () => {
    const router = useRouter()
    const { state: adsState, dispatch: adsDispatch, disclosures: adsDisclosures, onLoginSuccess } = useContext(AdsContext)
    const { state: userState, isUserTokenLoaded } = useContext(UserContext)

    const { isOpen: isOpenDeleteVariationModal, onOpen: onOpenDeleteVariationModal, onClose: onCloseDeleteVariationModal } = useDisclosure()
    const { isOpen: isOpenVariationPreviewModal, onOpen: onOpenVariationPreviewModal, onClose: onCloseVariationPreviewModal } = useDisclosure()

    const deleteVariation = useCallback((index) => {
        adsDispatch({ type: "SET_SELECTED_VARIATION", value: index })
        onOpenDeleteVariationModal()
    }, [adsState.campaign])

    const editVariation = useCallback((index) => {
        adsDispatch({ type: "SET_SELECTED_VARIATION", value: index })
        adsDisclosures.variationModalDisclosure.onOpen()
    }, [])

    const previewVariation = useCallback((index) => {
        adsDispatch({ type: "SET_SELECTED_VARIATION", value: index })
        onOpenVariationPreviewModal()
    }, [])

	const login = useGoogleLogin({ flow: 'auth-code', onSuccess: (res) => onLoginSuccess(res, true) })

    const loadCampaigns = useCallback(async ()=>{
		const {data} = await axios.get(`/api/campaigns/list`, { headers: { 'Content-Type': 'application/json', authorization: userState.token } })
        if (data.campaigns.length > 0) {
            const index = router.query.campaignId ? data.campaigns.findIndex(c => c.id === router.query.campaignId) : data.campaigns.length - 1 
            adsDispatch({ type: "SET_CAMPAIGNS", value: data.campaigns })
            adsDispatch({ type: "SET_CAMPAIGN_INDEX", value: index })
            adsDispatch({ type: "SET_CAMPAIGN", value: data.campaigns[index] })
            if (!router.query.campaignId) {
                router.push(`/ads/${data.campaigns[index].id}`,null, { shallow: true })
            }
        }
    }, [userState.token, router.query.campaignId])



    useEffect(() => {
		if (router.isReady && isUserTokenLoaded && router.query.campaignId && !userState.token) router.push('/ads')
	}, [userState.token, isUserTokenLoaded, router.isReady])

    useEffect(() => {
        if(userState.token && router.isReady) {
            loadCampaigns()
        }
    },[userState.token, router.isReady])
    return (
        <>
            <SocialHead />
            <Layout>
                <TopBar DesktopView={DesktopView} TabletView={TabletView} SelectProject={SelectProject} elements={adsState.campaigns} login={login}/>
                <Box w="full" h="full">
                    {(!adsState.campaign || adsState.campaign.variations.length === 0) && 
                        <Flex w="full" h="full" justify={'center'} align={'center'}>
                            <Button leftIcon={<Icon as={PlusCircleIcon} />} onClick={adsDisclosures.variationModalDisclosure.onOpen} colorScheme='purple'>{adsState.campaign ?  "Add variation": "New Campaign"}</Button>
                        </Flex>
                    }
                    {adsState.campaign &&
                        <Grid templateColumns='repeat(auto-fit, 400px)' gap="20px" justifyContent='center' mt="20">
                            {adsState.campaign.variations.map((v, i) => (
                                <Card h={'500px'} key={i}>
                                    <CardBody display="flex" flexDirection="column">
                                        <HStack spacing={1} padding={'4px'}>
                                            <Heading size='md'>{v?.title === '' ? 'Empty entry' : v?.title}</Heading>
                                            <IconButton onClick={() => editVariation(i)} ml="auto" icon={<Icon as={PencilSquareIcon} />} variant="ghost" />
                                            <IconButton onClick={() => deleteVariation(i)} colorScheme='red' icon={<Icon as={TrashIcon} />} variant="ghost" />
                                        </HStack>
                                        <Text fontSize={'xl'}>{v?.description === '' ? 'Empty entry' : v?.description}</Text>
                                        <Box mt="auto" position="relative">
                                            <Badge position="absolute" bottom="4%" left="2%" fontSize="14px" variant="solid" colorScheme={platformColor(v?.platform)}>{v?.platform ?? 'Empty entry'}</Badge>
                                            <Image src={v?.image} objectFit='cover' />
                                        </Box>
                                        <Flex mt="auto">
                                            <Button flex="1" ml="auto" size={"lg"} variant="outline" colorScheme='purple' leftIcon={<Icon as={EyeIcon}/>} onClick={() => previewVariation(i)}>Preview</Button>
                                        </Flex>
                                    </CardBody>
                                </Card>
                            ))}
                        </Grid>
                    }
                </Box>
                <VariationModal isOpen={adsDisclosures.variationModalDisclosure.isOpen} onClose={adsDisclosures.variationModalDisclosure.onClose} />
                <DeleteVariation isOpen={isOpenDeleteVariationModal} onClose={onCloseDeleteVariationModal}/>
                <VariationPreviewModal isOpen={isOpenVariationPreviewModal} onClose={onCloseVariationPreviewModal}/>
            </Layout>
        </>
    )
}

const Index = () => {
    return (
        <UserProvider>
            <AdsProvider>
                <Ads />
            </AdsProvider>
        </UserProvider>
    )
}

export default Index